import React from 'react';

import { SimpleIcon } from './icon-utils';

export function PencilIcon() {
  return (
    <SimpleIcon fill="none" height="15" viewBoxDimensions="0 0 14 15" width="14">
      <path
        d="M9.9165 2.25003C10.0651 2.07446 10.2488 1.93156 10.4561 1.83042C10.6634 1.72929 10.8896 1.67214 11.1203 1.66262C11.351 1.6531 11.5812 1.69141 11.7962 1.77513C12.0112 1.85884 12.2063 1.98611 12.369 2.14883C12.5317 2.31155 12.6585 2.50614 12.7413 2.72022C12.8241 2.93429 12.8611 3.16314 12.8499 3.39218C12.8386 3.62122 12.7795 3.84543 12.6762 4.05052C12.5729 4.25561 12.4277 4.43708 12.2498 4.58336L4.37484 12.4584L1.1665 13.3334L2.0415 10.125L9.9165 2.25003Z"
        stroke="#324A52"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 3.41669L11.0833 5.75002"
        stroke="#324A52"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SimpleIcon>
  );
}
